<template>
  <div class="chart-wrap">
    <highcharts v-if="options" :options="options"/>
    <div v-else class="text-muted small">Нет данных для графика</div>
  </div>
</template>

<script>
import { Chart } from 'highcharts-vue';

const TYPE_MAP = { bar: 'column', line: 'line', pie: 'pie' };

export default {
  name: 'ChartFromAi',
  components: { highcharts: Chart },
  props: {
    chart: { type: Object, required: true },
  },
  computed: {
    options() {
      const c = this.chart;
      if (!c || !Array.isArray(c.rows) || !c.rows.length) return null;
      const hcType = TYPE_MAP[c.type] || 'column';

      if (hcType === 'pie') {
        const data = c.rows.map(r => ({
          name: String(r[c.x_field] ?? ''),
          y: Number(r[c.y_field] ?? 0),
        }));
        return {
          chart: { type: 'pie', height: 300 },
          title: { text: c.title || '' },
          credits: { enabled: false },
          series: [{
            name: c.title || c.y_field,
            data,
          }],
        };
      }

      const categories = c.rows.map(r => String(r[c.x_field] ?? ''));
      const data = c.rows.map(r => Number(r[c.y_field] ?? 0));
      return {
        chart: { type: hcType, height: 300 },
        title: { text: c.title || '' },
        credits: { enabled: false },
        xAxis: { categories, title: { text: c.x_field } },
        yAxis: { title: { text: c.y_field } },
        legend: { enabled: true },
        series: [{
          name: c.title || c.y_field,
          data,
        }],
      };
    },
  },
};
</script>

<style scoped lang="scss">
.chart-wrap {
  max-width: 540px;
  margin: .75rem 0;
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: .5rem;
}
</style>
